import path from 'path';
export const createAssetPath = (assetEndpoint, manifestContent, assetPrefix = '') => assetKey => {
  const assetFile = manifestContent[assetKey] || path.join(assetPrefix, assetKey);
  return path.join(assetEndpoint, assetFile);
};